<template>
  <div class="wrapper" :class="'wrapper-' + $store.getters.platform">
    <app-loader v-if="!category && !noData"></app-loader>
    <div v-else>

      <Grid
        :options = "{
          type: !category.is_final ? 'card-categories' : 'card-contents',
          title: category.name,
          items: !category.is_final ? category.child_categories : category.category_content,
          route: !category.is_final ? 'content-category' : 'content-detail',
          card: category.card,
        }"
      />

    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Grid from '@/components/Grid'
import {StatsLiveCategories} from '@/utils/constants'
import { setLocation, getLocation } from '@/utils/helper-functions'
const contentsService = require('@/services/contents.js')

export default {
  name: 'RootContentCategories',
  components: { Grid, 'app-loader': Loader },
  data () {
    return {
      category: false,
      noData: false
    }
  },
  created: function () {
    const locale = localStorage.getItem('locale-demo')
    if (this.$store.getters.user) {
      this.locale = this.$store.getters.user.country2 ? this.$store.getters.user.country2.language.locale : this.$i18n.locale
    } else if (locale && this.$store.getters.getData.countries.length) {
      this.locale = locale
    } else {
      this.locale = this.$i18n.locale
    }

    this.getGeolocation()
  },
  beforeMount: function () {
    window.Countly.q.push(['track_pageview', StatsLiveCategories])
    window.scrollTo(0, 0)
  },
  mounted: function () {
    document.querySelector('body').style.overflowY = 'auto'
  },
  methods: {
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getCategories(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getCategories(position.coords.latitude, position.coords.longitude)
            },
            () => { this.getCategories(0, 0) },
            options)
        } else {
          this.getCategories(0, 0)
        }
      }
    },
    getCategories (lat, lon) {
      // CATEGORÍAS
      contentsService.listLiveCategories(lat, lon, this.locale).then(response => {
        if (response.data['results'].length) {
          this.category = response.data['results'][0]
        } else {
          this.noData = true
        }
      })
    },
    back: function () { this.$router.go(-1) }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  width: 100%
  min-height: calc(100vh - 75px);
  min-height: -o-calc(100vh - 75px); // opera
  min-height: -webkit-calc(100vh - 75px); // google, safari
  min-height: -moz-calc(100vh - 75px); // firefox
</style>



// WEBPACK FOOTER //
// src/pages/contents/LiveCategories.vue